const areFunctions = (...args) => args.every((arg) => typeof arg === "function");
const mergeFunctions = (a, b) => (...args) => {
    a(...args);
    b(...args);
};
const areObjects = (...args) => args.every((arg) => typeof arg === "object");
const mergeObjects = (a, b) => (Object.assign(Object.assign({}, a), b));
const mergeProps = (...propGroups) => {
    return propGroups.reduce((result, props) => {
        for (const key in props) {
            const a = result[key];
            const b = props[key];
            Object.assign(result, {
                [key]: areFunctions(a, b)
                    ? mergeFunctions(a, b)
                    : areObjects(a, b)
                        ? mergeObjects(a, b)
                        : b,
            });
        }
        return result;
    }, {});
};
export default mergeProps;
//# sourceMappingURL=mergeProps.js.map